import { memo, ReactNode, useCallback, useEffect } from 'react';
import { Navigate, Outlet } from 'react-router';
import ROUTES from 'shared/constants/routes';
import { Navigation } from 'shared/components/RockPaperScissors/Navigation/Navigation';
import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
import { useAppDispatch } from 'shared/helpers/useAppDispatch/useAppDispatch';
import { fetchState } from 'pages/RockPaperScissors/plays/model/services/fetchGameService';
import { useSelector } from 'react-redux';
import {
  getActiveGameError,
  getActiveGameId,
  getAppStateCurrentGames,
} from 'pages/RockPaperScissors/plays/model/selectors/getGamesData';
import { useStateSocket } from 'shared/helpers/socketHook/socketStateHook';
import { useGameState } from 'pages/RockPaperScissors/plays/model/HOC/useGameStateHook';
import { TAppState } from 'pages/RockPaperScissors/plays/model/types/gamesSchema';
import { gamesActions } from 'pages/RockPaperScissors/plays/model/slice/gamesSlice';
import { ErrorBoundaryWrapper } from 'shared/components/ErrorBoundaryWrapper/errorBoundaryWrapper';
import { ErrorGameDialog } from 'pages/RockPaperScissors/start/ui/errorGame/endGameDialog';
import { getInitDataState } from 'pages/login/store/selectors/loginSelectors';
import { Lightbox } from 'yet-another-react-lightbox';
import 'yet-another-react-lightbox/styles.css';

declare global {
  interface Window {
    Pusher: unknown;
    Echo: Echo;
  }
}

type TLandingLayoutRoute = {
  isAuth: boolean;
  children?: ReactNode;
};

window.Pusher = Pusher;

const GameLayoutRoute = ({ isAuth, children }: TLandingLayoutRoute) => {
  const dispatch = useAppDispatch();

  console.log('GAME_LAYOUT');
  const initDataId = useSelector(getInitDataState);

  const activeGameError = useSelector(getActiveGameError);

  const appStateCurrentGames = useSelector(getAppStateCurrentGames);
  const activeGameId = useSelector(getActiveGameId);

  useEffect(() => {
    if (isAuth) {
      dispatch(fetchState());
    }
    document.body.classList.add('body--games');
  }, [dispatch, isAuth]);

  useGameState(appStateCurrentGames?.rock_scissors_paper?.id, isAuth);

  useStateSocket({
    callBack: (e: { data: TAppState }) => {
      console.log('e GLOBAL_STATE', e);
      dispatch(gamesActions.setGlobalState(e.data));
    },
    id: initDataId?.toString() || '',
    isAuth,
  });

  console.log('plays route', isAuth);

  const onCancelActiveGameError = useCallback(() => {
    dispatch(gamesActions.cancelActiveGameError());
  }, [dispatch]);

  if (!isAuth) {
    return <Navigate to={ROUTES.LOGIN.ROUTE} replace />; // TODO Изменить страницу навигации
  }

  return (
    <ErrorBoundaryWrapper>
      <div className="container">
        <div className="wrapper wrapper--games">
          <main>{children ?? <Outlet />}</main>
          <Navigation />

          {/* {!activeGame?.id && <button onClick={onPlayGame}>play</button>} */}
          {/* {!!activeGame?.id && <button onClick={onLeaveGame}>leave</button>} */}
          {!!activeGameError && (
            <Lightbox
              open={true}
              close={onCancelActiveGameError}
              slides={[
                {
                  src: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMSIgaGVpZ2h0PSIxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxyZWN0IHdpZHRoPSIxIiBoZWlnaHQ9IjEiIGZpbGw9InRyYW5zcGFyZW50Ii8+PC9zdmc+',
                },
              ]}
              controller={{ closeOnPullDown: true, closeOnBackdropClick: true }}
              carousel={{
                finite: true,
              }}
              render={{
                slide: () => (
                  <ErrorGameDialog
                    onClose={onCancelActiveGameError}
                    message={activeGameError?.message}
                    gameId={activeGameId}
                    error={
                      activeGameError.status === 422
                        ? undefined
                        : activeGameError
                    }
                  />
                ),
                buttonPrev: () => null,
                buttonNext: () => null,
                buttonClose: () => null,
              }}
            />
          )}
        </div>
      </div>
    </ErrorBoundaryWrapper>
  );
};

export default memo(GameLayoutRoute);
